// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__Ro2N9","cell":"ColumnAccessor_cell__1114V","firstCellAccent":"ColumnAccessor_firstCellAccent__KIm9e"};